import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * The layout for every `/aircraft/*` route — an outlet only, the same shape
 * as `flights.tsx`: the register lives at the index, add/edit at their own
 * routes, so the URL says which of them is on screen.
 */
export const Route = createFileRoute('/aircraft')({
  component: Outlet,
});
